import { render, staticRenderFns } from "./Chinaopen.vue?vue&type=template&id=429054b8&scoped=true"
import script from "./Chinaopen.vue?vue&type=script&lang=js"
export * from "./Chinaopen.vue?vue&type=script&lang=js"
import style0 from "./Chinaopen.vue?vue&type=style&index=0&id=429054b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429054b8",
  null
  
)

export default component.exports